import React, {useEffect, useState} from "react";
import { Modal, Form, Input, Button, TreeSelect ,Select} from "antd";
import "./style.scss";
import PosService from "../../../services/PosService";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

const { Option } = Select;


export default function AssignEmployeeModal({ data, ...props }) {
  const formRef = React.createRef();
  const [form] = Form.useForm();
  const history = useHistory();
  const adminRestaurant = useSelector((state) => state.admin);
  const [selectedFloor, setSelectedFloor] = useState([])

  const onFinish = async(values) => {
    const res = await PosService.assignEmployee(data?.id, { section_ids: values?.sections})
    if(res){
      props.closeModal(false)
      history.push(`/pos/server-management`);
    }
  };

  useEffect(()=>{
    setSelectedFloor([...new Map(data?.sections?.map(item => [item.floor, item])).values()]?.map(item=>item.floor))
  },[data])

  const handleChange = (value) => {
    setSelectedFloor(value)
  }

  return (
    <Modal
      title={"Assign Employee"}
      open={props.modalOpen}
      footer={null}
      onCancel={() => props.closeModal(false)}
    >
      <Form initialValues={{floor:[...new Map(data?.sections?.map(item => [item.floor, item])).values()]?.map(item=>item.floor), sections: data?.sections?.map(item=>item.name), name: data?.name, code : data?.restaurant_role?.employee_code}}
        ref={formRef} form={form} 
      layout="vertical" onFinish={onFinish}>
        <Form.Item name="name" label="Name">
          <Input disabled={true} />
        </Form.Item>

        <Form.Item name="code" label="Code">
          <Input  disabled={true} />
        </Form.Item>
 <div style={{display:"flex", justifyContent:"space-between"}}>
 <Form.Item name="floor" label="Floor" style={{width:"45%"}}> 
 <Select
           mode="multiple"
            showSearch
            style={{ width: "100%" }}
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
            placeholder="Please select"
            allowClear
            multiple
            onChange={handleChange}
            value={data?.sections}
          >
                       {[...new Map(props.section.map(item => [item.floor, item])).values()]
                       .map(item=>  <Option key={item.id} value={item.floor}>Floor {item.floor}</Option>)}

            </Select>
            </Form.Item>
        <Form.Item name="sections" label="Section" style={{width:"45%"}}>
        <Select
           mode="multiple"
            showSearch
            style={{ width: "100%" }}
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
            placeholder="Please select"
            allowClear
            multiple
            value={data?.sections}
          >
                       {props.section && props.section?.filter(item=> selectedFloor.includes(item.floor))?. map(item=> 
                         <Option key={item.id} value={item.id}>Section {item.name} - Floor {item.floor}</Option>)}

            </Select>
        </Form.Item>
        </div>

        <Form.Item className="button-form">
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
